import React from 'react'
import { Footer } from '../Components/Footer'
import { Navbar } from '../Components/Navbar'
import { Heroimg } from '../Components/Heroimg'
import { AboutContent } from '../Components/AboutContent'
import { Skills } from '../Components/Skills'
import {ProjectCard} from "../Components/ProjectCard"
import { Form } from '../Components/Form'


export const Home = () => {
  return (
    <div>
        <Navbar />
        <Heroimg />
        <h1 style={{textAlign:"center" ,textDecoration:"underline",margin:"4rem 0"}}>About Me</h1>
        <AboutContent />
        <h1 style={{textAlign:"center",textDecoration:"underline",margin:"4rem 0"}}>Skills</h1>
        <Skills />
        <h1 style={{textAlign:"center",textDecoration:"underline",margin:"4rem 0"}}>Projects</h1>
        <ProjectCard />
        <h1 style={{textAlign:"center",textDecoration:"underline",margin:"4rem 0"}}>Contact</h1>
        <Form />
        <div style={{height:"250px",backgroundColor:"gray",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <h2 style={{textAlign:"center",color:"yellow",padding:"20px"}}>All copyrights reserved to © Rajesh Kumar</h2>
        </div>
    </div>
  )
}
